<template>
  <div>
    <div class="mb-4">
      <div style="display: flex">
        <img src="/static/img/assets/gblogo.svg" style="max-width: 50px; width: 100%" alt />
        <div class="pl-3" style="overflow: auto">
          <h2 class=" mt-0" style="">
            {{ $t('GB Prime Credit Card') }}
          </h2>
        </div>
      </div>
    </div>
    <div class="mt-3">
      {{
        $t(
          'GB Prime payment makes it easy to pay by credit or debit card. Customer has no need to attach the payment proof. It comes with the Chat2Pay system that makes it easy to open billing via chat. Just send a message to the customer for billings, followed by the product price and details. The system will provide the payment link to the customer immediately. Sign up for free today.'
        )
      }}
      <a
        href="https://tinyurl.com/bdz4m3e5"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('How to use') }}?
      </a>
    </div>
    <div v-if="loading" class="spinner text-xs-center">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>
    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('Apply for GB Prime') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>
            <carousel :items="1" :autoHeight="true" :nav="false">
              <div>
                <img
                  v-if="currentLang == 'th'"
                  src="/static/img/assets/chat2pay/step1.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; width: 100%"
                />
                <img
                  v-else
                  src="/static/img/assets/chat2pay/step1_en.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; width: 100%"
                />
                <p style="margin-top: 15px; margin-bottom: 0">
                  {{ $t('Sign up to get paid with GB Prime Pay at') }}
                  <a
                    href="https://www.gbprimepay.com/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    >https://www.gbprimepay.com/register</a
                  >
                  {{ $t('Fill in your information and') }}
                  <span class="primary-color">
                    {{
                      $t(
                        'use referral code (Ref): “chat2pay” to get a special payment rate (2.9% fee for pay with credit card and 0.5% fee for pay via QR Code)'
                      )
                    }}</span
                  >
                  {{ $t('After 1-3 days, go to profile page to receive a Token') }}
                </p>

                <div class="caption">
                  <p>
                    {{
                      $t(
                        'Note: If you have some subscription problems, please call. +66-2645-3781, +66-2248-6397-99, +6692-436-3481 (24 hours)'
                      )
                    }}
                  </p>
                </div>
              </div>
              <div>
                <img
                  v-if="currentLang == 'th'"
                  src="/static/img/assets/chat2pay/step2.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; width: 100%"
                />
                <img
                  v-else
                  src="/static/img/assets/chat2pay/step2_en.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; width: 100%"
                />
                <p style="margin-top: 15px; margin-bottom: 0">
                  {{ $t('Bring token from Profile page') }} (<a href="https://www.gbprimepay.com/merchant/profile" target="_blank" rel="noopener noreferrer">https://www.gbprimepay.com/merchant/profile</a>) {{ $t('and send email to') }}
                </p>
              </div>
              <div>
                <img
                  src="/static/img/assets/chat2pay/step3.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; width: 100%"
                />
                <p style="margin-top: 15px; margin-bottom: 0">
                  {{
                    $t(
                      'Get started with Chat2pay by admin texting to the customer as “open the bill”, followed by details and price. The system will send a payment link to your customer immediately and the earnings are deposited'
                    )
                  }}
                  <span class="primary-color">{{
                    $t('to your bank account every Wednesday.')
                  }}</span>
                </p>
              </div>
            </carousel>
            <v-btn
              @click="step = 2"
              href="https://www.gbprimepay.com/register"
              target="_blank"
              color="primary"
              depressed
              class="mx-0"
              >{{ $t('Register GB Prime') }}</v-btn
            >
          </div>
        </v-stepper-content>

        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('Connect Zwiz to GB Prime') }}
        </v-stepper-step>

        <v-stepper-content step="2">
          <div class="mb-2" v-if="!showCreditcardCancel">
            {{
              $t(
                `After GB Prime is verified, Secret Key, Public Key and Token can be taken. Let's enter to make a connection here.`
              )
            }}
          </div>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <gbprime-credit-card
                :key="'creditcard_' + creditcard_timestamp"
                v-model="isCreditCardEdit"
                :gbprime_secretkey="gbprime_secretkey"
                :gbprime_publickey="gbprime_publickey"
                :gbprime_token="gbprime_token"
                @onEdit="editCreditcard"
                @onSave="onSaveCreditCard"
                @onCancel="onCancelCreditCard"
                :showCancel="showCreditcardCancel"
              >
                <div slot="status">
                  <div class="mb-2" v-if="showCreditcardCancel">
                    <div>
                      {{ $t('enable_disable_gb_credit') }}
                    </div>
                    <div>
                      <toggle-button
                        class="mt-2"
                        :value="gbprimecredit_status"
                        :sync="true"
                        :color="$vuetify.theme.success"
                        @change="toggleStatus"
                        :labels="{ checked: 'ON', unchecked: 'OFF' }"
                        style="display: inline-block"
                      />
                    </div>
                  </div>
                </div>
                <div slot="qrstatus">
                  <div class="mb-2" v-if="showCreditcardCancel">
                    <div>
                      {{ $t('enable_disable_qr_credit') }}
                    </div>
                    <div>
                      <toggle-button
                        class="mt-2"
                        :value="gbprime_status"
                        :sync="true"
                        :color="$vuetify.theme.success"
                        @change="toggleQRStatus"
                        :labels="{ checked: 'ON', unchecked: 'OFF' }"
                        style="display: inline-block"
                      />
                    </div>
                  </div>
                </div>
              </gbprime-credit-card>
              <!-- <gbprime-qrcode
                :key="'qrcode_' + qrcode_timestamp"
                v-model="isQrcodeEdit"
                :gbprime_token="gbprime_token"
                @onEdit="editQrcode"
                @onSave="onSaveQrcode"
                @onCancel="onCancelQrcode"
                :showCancel="showQrcodeCancel"
              >
                <div slot="status">
                  <div class="mb-2" v-if="showQrcodeCancel">
                    <div>
                      {{ $t('เปิด/ปิด การใช้งาน GB Prime QR') }}
                    </div>
                    <div>
                      <label
                        class="toggle-switch small"
                        style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                      >
                        <input
                          :disabled="loading"
                          type="checkbox"
                          :checked="gbprime_status"
                          @change="toggleQRStatus()"
                        />
                        <span class="toggle-slider lever round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </gbprime-qrcode> -->
            </v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import carousel from 'vue-owl-carousel'
import api from '@/api'
import GbprimeCreditCard from './GbprimeCreditCard.vue'
import GbprimeQrcode from './GbprimeQrcode.vue'
import dayjs from 'dayjs'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  data() {
    return {
      step: 1,
      isCreditCardEdit: false,
      isQrcodeEdit: false,
      showCreditcardCancel: true,
      showQrcodeCancel: true,
      loading: true,
      gbprimecredit_status: null,
      gbprime_secretkey: null,
      gbprime_publickey: null,
      gbprime_status: false,
      gbprime_token: '',
      creditcard_timestamp: dayjs().format('x'),
      qrcode_timestamp: dayjs().format('x')
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  components: { ToggleButton, carousel, GbprimeQrcode, GbprimeCreditCard },
  async mounted() {
    this.loading = true
    var response = await this.getgbprimecredit()
    if (response.responsecode == 200 && response.data && response.data.length > 0) {
      this.gbprime_secretkey = response.data[0].gbprime_secretkey
      this.gbprime_publickey = response.data[0].gbprime_publickey
      this.gbprimecredit_status = response.data[0].gbprimecredit_status
      // qr code
      this.gbprime_status = response.data[0].gbprime_status
      this.gbprime_token = response.data[0].gbprime_token
    }
    if (!(this.gbprime_secretkey && this.gbprime_publickey) || !this.gbprime_token) {
      this.editCreditcard()
      this.showCreditcardCancel = false
    }
    // if (!this.gbprime_token) {
    //   this.editQrcode()
    //   this.showQrcodeCancel = false
    // }
    if ((this.gbprime_secretkey && this.gbprime_publickey) || this.gbprime_token) {
      this.step = 2
    }
    this.loading = false
  },
  methods: {
    async onSaveCreditCard(payload) {
      this.gbprime_secretkey = payload.gbprime_secretkey
      this.gbprime_publickey = payload.gbprime_publickey
      this.gbprime_token = payload.gbprime_token
      await this.onSave()
      // qr code
      this.cached_gbprime_status = this.gbprime_status
      this.cached_gbprime_token = this.gbprime_token

      this.cached_gbprime_secretkey = this.gbprime_secretkey
      this.cached_gbprime_publickey = this.gbprime_publickey
      this.cached_gbprimecredit_status = this.gbprimecredit_status
      this.isCreditCardEdit = false
      this.showCreditcardCancel = true
      this.creditcard_timestamp = dayjs().format('x')
    },
    onCancelCreditCard() {
      this.isCreditCardEdit = false
      this.creditcard_timestamp = dayjs().format('x')
      this.gbprime_secretkey = this.cached_gbprime_secretkey
      this.gbprime_publickey = this.cached_gbprime_publickey
      this.gbprimecredit_status = this.cached_gbprimecredit_status
      //qr code
      this.gbprime_status = this.cached_gbprime_status
      this.gbprime_token = this.cached_gbprime_token
    },
    async onSaveQrcode(payload) {
      this.gbprime_token = payload.gbprime_token
      await this.onSave()
      this.cached_gbprime_status = this.gbprime_status
      this.cached_gbprime_token = this.gbprime_token
      this.isQrcodeEdit = false
      this.showQrcodeCancel = true
      this.qrcode_timestamp = dayjs().format('x')
    },
    onCancelQrcode() {
      this.isQrcodeEdit = false
      this.qrcode_timestamp = dayjs().format('x')

      this.gbprime_status = this.cached_gbprime_status
      this.gbprime_token = this.cached_gbprime_token
    },
    editCreditcard() {
      this.isCreditCardEdit = true
      this.cached_gbprime_secretkey = this.gbprime_secretkey
      this.cached_gbprime_publickey = this.gbprime_publickey
      this.cached_gbprimecredit_status = this.gbprimecredit_status
      this.cached_gbprime_status = this.gbprime_status
      this.cached_gbprime_token = this.gbprime_token
    },
    editQrcode() {
      this.isQrcodeEdit = true
      this.cached_gbprime_status = this.gbprime_status
      this.cached_gbprime_token = this.gbprime_token
    },
    async toggleQRStatus() {
      var vm = this
      const status = !vm.gbprime_status
      try {
        await vm.savegbprimecredit({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            gbprimecredit_status: this.gbprimecredit_status,
            gbprime_secretkey: this.gbprime_secretkey,
            gbprime_publickey: this.gbprime_publickey,
            gbprime_status: status,
            gbprime_token: this.gbprime_token
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.gbprime_status = status
      } catch (error) {
        console.log(error)
      }
    },
    async toggleStatus() {
      var vm = this
      const status = !vm.gbprimecredit_status
      try {
        await vm.savegbprimecredit({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            gbprimecredit_status: status,
            gbprime_secretkey: this.gbprime_secretkey,
            gbprime_publickey: this.gbprime_publickey,
            gbprime_status: this.gbprime_status,
            gbprime_token: this.gbprime_token
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.gbprimecredit_status = status
      } catch (error) {
        console.log(error)
      }
    },
    async onSave() {
      try {
        if (
          this.gbprime_secretkey != null &&
          this.gbprime_publickey != null &&
          this.gbprimecredit_status == null
        )
          this.gbprimecredit_status = true

        if (this.gbprime_token != null && this.gbprime_status == null) this.gbprime_status = true
        if (this.gbprime_token == null) this.gbprime_token = false
        if (this.gbprime_status == null) this.gbprime_status = false
        this.loading = true

        await this.savegbprimecredit({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            gbprimecredit_status: this.gbprimecredit_status,
            gbprime_secretkey: this.gbprime_secretkey,
            gbprime_publickey: this.gbprime_publickey,
            gbprime_status: this.gbprime_status,
            gbprime_token: this.gbprime_token
          }
        })
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })

        this.loading = false
      } catch (error) {}
    },
    getgbprimecredit() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getgbprimecredit({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    savegbprimecredit(data) {
      return new Promise((resolve, reject) => {
        api.savegbprimecredit(data, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/GbprimePayment.vue